import { useMemo } from 'react';
import { useBusinessStore } from '../store/useBusinessStore';
import { isPaidOrder } from '../utils/orders';

export const useFinances = () => {
  const { masterDb, activeBusinessId } = useBusinessStore();
  const activeBusiness = masterDb.find(b => String(b.id) === String(activeBusinessId));

  const stats = useMemo(() => {
    if (!activeBusiness) return null;

    const apptsPaid = (activeBusiness.appointments || [])
      .filter(a => (a.status === "Completada" || a.status === "Confirmada") && a.estado_pago === "Pagado")
      .reduce((acc, a) => acc + (a.precio_cobrado || 0), 0);

    const ordersPaid = (activeBusiness.orders || [])
      .filter(isPaidOrder)
      .reduce((acc, o) => acc + (o.total || 0), 0);
      
    let totalPaid = apptsPaid + ordersPaid;

    const apptsPending = (activeBusiness.appointments || [])
      .filter(a => a.status !== "Cancelada" && a.estado_pago !== "Pagado")
      .reduce((acc, a) => acc + (a.precio_cobrado || 0), 0);

    const ordersPending = (activeBusiness.orders || [])
      .filter(o => o.status === "pending" || o.status === "in_preparation" || o.status === "shipped")
      .reduce((acc, o) => acc + (o.total || 0), 0);
      
    let totalPending = apptsPending + ordersPending;

    return {
      totalPaid,
      totalPending,
      displayApptsPaid: apptsPaid,
      displayOrdersPaid: ordersPaid
    };
  }, [activeBusiness]);

  return {
    activeBusiness,
    stats
  };
};
